import React, { useEffect, useState, useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  TextField,
  Box,
  Paper,
  Typography,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import Cookies from "universal-cookie";

import CrearUsuario from "./CreaUusario";
import EliminarUsuario from "./EliminaUsuario";
import { obtenerUsuarios } from "../../Services/Rest";

function InfoUsuarios() {
  const cookie = new Cookies();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const userType = Number(cookie.get("tipo"));

  // 🔥 FETCH
  useEffect(() => {
    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "get",
      url: obtenerUsuarios + cookie.get("ID"),
    })
      .then((res) => {
        const data = res.data.map((item) => ({
          id: item.id,
          nombre: item.nombre,
          correo: item.correo,
          tipo: item.tipo === 1 ? "Administrador" : "Usuario",
        }));

        setRows(data);

        if (res.data.length > 0) {
          cookie.set("tipo", res.data[0].tipo, { path: "/" });
        }
      })
      .catch(console.log)
      .finally(() => setLoading(false));
  }, []);

  // 🔍 BUSCADOR GLOBAL
  const filteredRows = useMemo(() => {
    return rows.filter((row) =>
      Object.values(row).join(" ").toLowerCase().includes(search.toLowerCase()),
    );
  }, [search, rows]);

  // 📊 COLUMNAS
  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "nombre", headerName: "Nombre", flex: 1 },
    { field: "correo", headerName: "Correo", flex: 1 },
    { field: "tipo", headerName: "Tipo", width: 150 },
    ...(userType === 1
      ? [
          {
            field: "acciones",
            headerName: "",
            width: 120,
            sortable: false,
            renderCell: (params) => <EliminarUsuario id={params.row.id} />,
          },
        ]
      : []),
  ];

  return (
    <Box sx={{ p: 3 }}>
      {/* 🔥 HEADER */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Usuarios
        </Typography>

        {userType === 1 && <CrearUsuario />}
      </Box>

      {/* 🔍 BUSCADOR FLOTANTE */}
      <Box sx={{ mb: -3, zIndex: 2, position: "relative" }}>
        <Paper
          elevation={4}
          sx={{
            p: 1.5,
            borderRadius: 3,
            width: 350,
            mx: "auto",
          }}
        >
          <TextField
            fullWidth
            size="small"
            placeholder="Buscar en toda la tabla..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Paper>
      </Box>

      {/* 📊 TABLA */}
      <Paper
        elevation={2}
        sx={{
          borderRadius: 3,
          pt: 4,
          overflow: "hidden",
        }}
      >
        <Box sx={{ height: "70vh" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            loading={loading}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 20]}
            pagination
            disableSelectionOnClick
            sx={{
              border: "none",

              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f8fafc",
                fontSize: "0.85rem",
              },

              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f1f5f9",
              },
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
}

export default InfoUsuarios;
